import type { IconData } from '@stacksjs/iconify-core'

export const disableHeart: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M8.136 8.148c4.18-2.902 10.103-3.047 14.362.699c.523.456.988.983 1.502 1.508c.514-.525.98-1.052 1.502-1.508c6.6-5.805 17.196-2.266 19.11 6.396c.895 3.803.225 7.893-1.834 11.194c-2.013 3.232-4.714 6.065-7.695 8.647M4.621 12a11.8 11.8 0 0 0-1.233 3.243c-.895 3.803-.225 7.893 1.834 11.194c3.603 5.786 9.413 10.29 15.08 14.374a6.34 6.34 0 0 0 7.396 0a186 186 0 0 0 3.078-2.264M3 3l40 40\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default disableHeart
